import Print from "../../parts/Print";
import ContentRent from "./ContentRent";
import ContentMonitoring from "./ContentMonitoring";
import { useParams } from "react-router-dom";

const ContractsView = () => {
  const { type, uuid } = useParams();
  return (
    <Print>
      {type === "locacao" ? (
        <ContentRent uuid={uuid!} />
      ) : (
        <ContentMonitoring uuid={uuid!} />
      )}
    </Print>
  );
};

export default ContractsView;
